// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ns-email-simple_ZkMBY input[type=text]:focus{border:1px solid #94d6e9!important}", ""]);
// Exports
exports.locals = {
	"ns-email-simple": "ns-email-simple_ZkMBY"
};
module.exports = exports;
